import { render, staticRenderFns } from "./workplaces_ad.vue?vue&type=template&id=4201b507&scoped=true&"
import script from "./workplaces_ad.vue?vue&type=script&lang=js&"
export * from "./workplaces_ad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4201b507",
  null
  
)

export default component.exports